
import { Injectable, NgModule } from '@angular/core';
import { Actions } from '@ngrx/effects';
import { Store } from '@ngrx/store';

@Injectable({
  providedIn: 'root'
})
export class NgrxStore {
  static store: Store<any> | null = null;

  connect(store: Store<any>) {
    NgrxStore.store = store;
  }
}

@Injectable({
  providedIn: 'root'
})
export class NgrxActions {
  static actions$: Actions | null = null;

  connect(actions: Actions) {
    NgrxActions.actions$ = actions;
  }
}

@NgModule()
export class DecoratorsModule {

  constructor(ngrxStore: NgrxStore, store: Store<any>, ngrxActions: NgrxActions, actions: Actions) {
    if (NgrxStore.store == null) {
      ngrxStore.connect(store);
    }
    if (NgrxActions.actions$ == null) {
      ngrxActions.connect(actions);
    }
  }

}
